// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedFootTrigger_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8394 14.677C15.4526 14.7016 15.0634 14.6303 14.7194 14.4517L10.5393 12.2819C10.208 12.1099 10 11.7677 10 11.3943L10.0001 0.00195312L1.00793 3.02153C1.05649 3.1573 1.10766 3.30941 1.16066 3.47635C1.928 5.89341 3.0788 11.4209 2.24297 15.5208C1.34941 19.9038 3.57256 21.3347 4.99956 21.5015L15.8237 21.5005C15.9401 21.5004 16.0557 21.4801 16.1651 21.4404L22.1121 19.2799C22.3707 19.1859 22.5064 18.9008 22.4192 18.6398C21.8127 16.8233 20.9744 14.3509 15.8394 14.677ZM5.15124 19.5015L15.6476 19.5005L19.9743 17.9286C19.8452 17.7066 19.6995 17.5241 19.5169 17.3657C19.1202 17.0216 18.2176 16.53 15.9661 16.673C15.255 16.7181 14.4975 16.59 13.798 16.2268L9.61787 14.057C8.62385 13.541 8.00001 12.5143 8.00002 11.3943L8.00008 2.78331L3.47186 4.30389C3.7501 5.39987 4.02349 6.72359 4.22278 8.13618C4.56287 10.5467 4.71533 13.4056 4.20266 15.9203C3.82795 17.7583 4.17241 18.6215 4.41115 18.9768C4.63402 19.3086 4.93433 19.4546 5.15124 19.5015Z" class="svg-bg"/>
  <path d="M13 23.9999L24 19.9999V23.9999H13Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedFootTrigger is a generated icon component.
 */
let IconMedFootTrigger = IconMedFootTrigger_1 = class IconMedFootTrigger extends IconBaseElement {
    render() {
        return html `${IconMedFootTrigger_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedFootTrigger.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedFootTrigger = IconMedFootTrigger_1 = __decorate([
    customElement('zui-icon-med-foot-trigger')
], IconMedFootTrigger);
export { IconMedFootTrigger };
